var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('span', [_setup.hasFloor ? _c('span', [_c(_setup.FloorOutput, {
    attrs: {
      "input": _setup.floor,
      "type": _vm.floorType
    }
  })], 1) : _vm._e(), _vm._v(" "), _setup.hasDelimiter ? _c('span', [_vm._v("\n    " + _vm._s(_vm.delimiterSymbol) + "\n  ")]) : _vm._e(), _vm._v(" "), _setup.hasNumber ? _c('span', [_c(_setup.ApartmentNumberOutput, {
    attrs: {
      "input": _setup.number,
      "type": _vm.numberType
    }
  })], 1) : _vm._e(), _vm._v(" "), _setup.isEmpty ? _c('span', [_vm._v("\n    " + _vm._s(_vm.empty) + "\n  ")]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };